import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { Button, Checkbox, Spin, Tooltip } from 'antd';

import { Edit, Info } from '../../../assets/icons';

import { getUserProfileApi, kycAmlVerify } from '../../../services/authApi/userApi';
import { addUserData } from '../../../store/reducer/accountSlice';
import { dwollaAgreementsAction } from '../../../store/reducer/onbordingSlice';
import { formatePhoneNumber } from '../../../utils/formatPhoneNumber';
import { toastNotify } from '../../../utils/toastNotify';

const StepSix = (props) => {
  const [loading, setLoading] = useState(false);
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);
  const { userData: userProfile } = useSelector((state) => state.userData);
  const { loading: agreementLoading } = useSelector((state) => state.dwollaAgreement);
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const getUserProfile = async () => {
    setLoading(true);
    try {
      const resData = await getUserProfileApi();

      if (!resData.isError) {
        const { data } = resData;
        dispatch(addUserData({ userData: data?.user }));
        navigate('/sign-up/linkbank');
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const residentialAdd = userProfile?.address?.residentialAdd || '';
  const apartmentNumber = userProfile?.address?.apartmentNumber || '';
  const city = userProfile?.address?.city;
  const state = userProfile?.address?.state;
  const zipCode = userProfile?.address?.zipCode;

  // let { residentialAdd, apartmentNumber, city, state, zipCode } = Object.keys(userProfile).length > 0 && userProfile?.address;
  const addressDeatilOne = userProfile ? `${residentialAdd}, ${apartmentNumber}` : '';
  const addressDeatilTwo = userProfile ? `${city}, ${state}, ${zipCode}` : '';
  const phoneNumber = [userProfile?.countryCode, formatePhoneNumber(userProfile?.phoneNumber)];
  const ssnFormate = userProfile && userProfile.ssn ? `XXX-XX-X${userProfile.ssn.slice(8, 11)}` : '';
  const legalName = [userProfile?.firstName, ' ', userProfile?.lastName];
  const accreStatus =
    Object.keys(userProfile).length > 0 && Object.keys(userProfile.investorStatus).some((val) => userProfile.investorStatus[val] === true);
  const userProfileData = useSelector((state) => state.userData);

  const stepSixData = [
    {
      title: 'Legal Name',
      detail1: legalName,
      step: 'StepOne',
      isEdited: false,
      isLegalTooltip: true,
    },
    {
      title: 'Email',
      detail1: userProfile?.email,
      step: 'StepOne',
      isEdited: false,
      isEmailTooltip: true,
    },
    {
      title: 'Country of Residence',
      detail1: 'USA',
      step: 'StepOne',
      isEdited: false,
    },
    {
      title: 'Residential Address',
      detail1: addressDeatilOne,
      detail2: addressDeatilTwo,
      step: 'StepTwo',
      isEdited: true,
    },
    {
      title: 'Phone Number',
      detail1: phoneNumber,
      step: 'StepTwo',
      isEdited: true,
    },
    {
      title: 'SSN',
      detail1: ssnFormate,
      step: 'StepThree',
      isEdited: true,
    },
    {
      title: 'Date Of Birth',
      // detail1: '10/08/1975',
      detail1: userProfile?.dob,
      step: 'StepThree',
      isEdited: true,
    },
    {
      title: 'Accredited Investor Status',
      detail1: accreStatus ? 'Accredited' : 'Not Accredited',
      step: 'StepFour',
      isEdited: true,
    },
  ];

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const userData = await kycAmlVerify();
      if (!userData.isError) {
        toastNotify('success', userData?.message);
        getUserProfile();
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      if(response?.data?.message === 'Identity is already verified.'){
        toastNotify('success', response?.data?.message);
      } else {
        toastNotify('error', response?.data?.message);
      }
      navigate('/account');
    } finally {
      setLoading(false);
    }
  };

  const handleClickOnAgreement = async () => {
    await dispatch(
      dwollaAgreementsAction({
        onSuccess: () => setIsAgreementChecked(!isAgreementChecked),
      })
    );
  };

  return (
    <>
      {userProfileData?.userData?.isKYCVerified ? (
        <>
          <p>you have already been verified please go to home</p>
          <Button href='/' type='primary'>
            Realbricks Marketplace
          </Button>
        </>
      ) : (
        <div className='stepsix review'>
          <div className='review__list'>
            {stepSixData.map((data, index) => (
              <div className='review__item' key={index}>
                <div>
                  <span className='review__title'>{data.title}</span>
                  <p className='mb-0 fw-500 review__detail'>{data.detail1}</p>
                  {data.detail2 && <p className='mb-0 fw-500 review__detail'>{data.detail2}</p>}
                </div>
                {data.isLegalTooltip && (
                  <Tooltip
                    placement='leftBottom'
                    className='fw-600 review__edit'
                    title={
                      <>
                        <p>
                          Legal name is editable once you completed onboarding. If you wish to edit now. Please contact{' '}
                          <a href='mailto:support@realbricks.com'>support@realbricks.com</a>
                        </p>
                      </>
                    }
                  >
                    {' '}
                    <Info marginLeft='7px' top='5px' className='fw-600 review__edit' size={18} />{' '}
                  </Tooltip>
                )}
                {data.isEmailTooltip && (
                  <Tooltip
                    placement='leftBottom'
                    className='fw-600 review__edit'
                    title={
                      <>
                        <p>
                          Email is editable once you completed onboarding. If you wish to edit now. Please contact{' '}
                          <a href='mailto:support@realbricks.com'>support@realbricks.com</a>
                        </p>
                      </>
                    }
                  >
                    {' '}
                    <Info marginLeft='7px' top='5px' className='fw-600 review__edit' size={18} />{' '}
                  </Tooltip>
                )}
                {data.isEdited && (
                  <div className='fw-600 review__edit' onClick={() => props.nextAction(data.step)}>
                    <Edit verticalAlign='middle' marginRight='8px' top='-2px' /> <span>Edit</span>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className='mt-32' onClick={() => handleClickOnAgreement()}>
            {agreementLoading ? <Spin className='mr-8' spinning={agreementLoading} /> : <Checkbox className='mr-8' checked={isAgreementChecked} />}
            <span className='cursor-pointer'>
              I have read and agree to Dwolla{' '}
              <Link to={{ pathname: '/legal', hash: 'Privacy Policy' }} className='fw-600 underline'>
                privacy policy{' '}
              </Link>
              and{' '}
              <Link to={{ pathname: '/legal', hash: 'Terms of use' }} className='fw-600 underline'>
                term and conditions
              </Link>{' '}
              .
            </span>
          </div>
          <div className='auth-form__fixed-submit'>
            <Button disabled={!isAgreementChecked} loading={loading} type='primary' className='ant-btn-primary--alt'>
              <Link className='text-white' onClick={() => handleConfirm()}>
                Confirm
              </Link>
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

StepSix.propTypes = {
  nextAction: PropTypes.func,
};

export default StepSix;
